// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 32px 24px 24px;
  text-align: center;
}
.container img {
  width: 66px;
  height: 66px;
}
.container h2 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}
.container p {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}
.container ion-button {
  width: 100%;
  font-weight: 600;
}
.container .dismiss-btn {
  background: none;
  border: none;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  padding: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/app-update-modal/app-update-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;AACJ;AAEE;EACE,eAAA;EACA,iBAAA;EACA,SAAA;AAAJ;AAGE;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AADJ;AAIE;EACE,WAAA;EACA,gBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAHJ","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  padding: 32px 24px 24px;\n  text-align: center;\n\n  img {\n    width: 66px;\n    height: 66px;\n  }\n\n  h2 {\n    font-size: 20px;\n    font-weight: bold;\n    margin: 0;\n  }\n\n  p {\n    font-size: 14px;\n    color: #666;\n    margin: 0;\n    line-height: 1.5;\n  }\n\n  ion-button {\n    width: 100%;\n    font-weight: 600;\n  }\n\n  .dismiss-btn {\n    background: none;\n    border: none;\n    color: #666;\n    font-size: 14px;\n    cursor: pointer;\n    padding: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
